import {Button, DatePicker, Form, Input, Modal, Select, message} from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, {useEffect, useState} from "react";
import api from "../../api";
import dayjs from "dayjs";
import {submitValidatedForm} from "../../formValidation";

export default function CreateTaskModal({open, onCancel, onSuccess, gardens}) {
    const [form] = Form.useForm();
    const [beds, setBeds] = useState([]);
    const [selectedGardenId, setSelectedGardenId] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (selectedGardenId) {
            api.beds(selectedGardenId).then(setBeds);
        } else {
            setBeds([]);
        }
    }, [selectedGardenId]);

    useEffect(() => {
        if (!open) {
            form.resetFields();
            setSelectedGardenId(null);
            setBeds([]);
        }
    }, [open, form]);

    function handleGardenChange(gardenId) {
        setSelectedGardenId(gardenId);
        form.setFieldValue('bed_id', null);
    }

    function handleSubmit() {
        return submitValidatedForm(form, values => {
            setIsSubmitting(true);
            const taskData = {
                title: values.title,
                description: values.description || null,
                due_at: values.due_at.format('YYYY-MM-DD'),
                garden_id: values.garden_id,
                bed_id: values.bed_id || null
            };
            return api.createTask(taskData).then(() => {
                message.success('Taak aangemaakt');
                form.resetFields();
                setSelectedGardenId(null);
                setBeds([]);
                onSuccess();
                onCancel();
            }).catch(() => {
                message.error('Er ging iets mis');
            }).finally(() => {
                setIsSubmitting(false);
            });
        });
    }

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={(
                <Button type="primary" onClick={handleSubmit} loading={isSubmitting}>
                    Taak aanmaken
                </Button>
            )}
        >
            <h1>Nieuwe taak</h1>
            <Form form={form} layout="vertical">
                <Form.Item
                    name="title"
                    label="Titel"
                    rules={[{required: true, message: 'Vul een titel in'}]}
                >
                    <Input placeholder="Bijv. Onkruid wieden"/>
                </Form.Item>
                <Form.Item name="description" label="Beschrijving">
                    <TextArea
                        autoSize={{minRows: 2, maxRows: 6}}
                        placeholder="Optionele beschrijving..."
                    />
                </Form.Item>
                <Form.Item
                    name="due_at"
                    label="Deadline"
                    rules={[{required: true, message: 'Selecteer een datum'}]}
                >
                    <DatePicker
                        style={{width: '100%'}}
                        format="DD-MM-YYYY"
                        defaultPickerValue={dayjs()}
                    />
                </Form.Item>
                <Form.Item
                    name="garden_id"
                    label="Tuin"
                    rules={[{required: true, message: 'Selecteer een tuin'}]}
                >
                    <Select
                        placeholder="Selecteer een tuin"
                        onChange={handleGardenChange}
                        options={gardens.map(garden => ({
                            value: garden.id,
                            label: garden.name
                        }))}
                    />
                </Form.Item>
                <Form.Item name="bed_id" label="Bed (optioneel)">
                    <Select
                        placeholder="Selecteer een bed"
                        allowClear
                        disabled={!selectedGardenId}
                        options={beds.map(bed => ({
                            value: bed.id,
                            label: bed.name
                        }))}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
}
